import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsFillAwardFill } from "react-icons/bs";

function CertificationCard(props) {
  return (
    <Card className="certification-card-view">
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Card.Text style={{ color: "gray" }}>
          <strong>Issued By:</strong> {props.issuer} <br />
          <strong>Completion Date:</strong> {props.completionDate}
        </Card.Text>
        {props.certLink && (
          <>
            <div className="cert-verified">
              <span className="cert-verified-dot"></span>
              Verified Credential
            </div>
            <Button variant="primary" href={props.certLink} target="_blank" style={{ marginTop: "8px" }}>
              <BsFillAwardFill /> &nbsp; View Certification
            </Button>
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default CertificationCard;
